module.exports = __webpack_public_path__ + "img/logo-sesb-navbar.d7d77b1e.png";